export function fillArrayWithNumbers(
  count: number,
  options?: { startingNumber: number },
): number[] {
  const startingNumber = options?.startingNumber || 0;
  return Array.from({ length: count }, (_, index) => index + startingNumber);
}
